
   <div class="flex-grow-1 d-flex">
    <ds-icon
      name="rds-icon-warning-filled"
      class="mr-8 ds-icon d-inline-flex fds-icon-warning-filled ds-color-warning 
      ds-icon d-inline-flex cds-icon-warning-filled ds-color-warning"
      [color]="'warning'">
    </ds-icon>
    <div>
        <p class="text-body">
      <span>
        <div>
          <b>{{ 'drs.deny.header' | translate }}</b>
        </div>
      </span>
      </p>
    </div>
  </div>

   <div class="text-body-lg mb-10 mt-10">
     <p>{{ 'drs.deny.body' | translate }}</p>
   </div>

    <div>
     <b>{{ 'drs.deny.reference' | translate }} {{ correlationId }}</b>
     <span style="display: inline-flex;">
      <ds-icon
      name="rds-icon-copy"
      class="ml-16 mr-8 ds-icon d-inline-flex fds-icon-copy ds-color-info 
      ds-icon d-inline-flex cds-icon-copy ds-color-info"
      style="cursor: pointer;"
      [color]="'info'"
      (click)="OnCopyReference()">
     </ds-icon>  
      <p style="color: #00889c !important; margin-top: 3px;" class="text-body-sm">{{ 'drs.deny.copy' | translate }}</p>    
      </span>
    </div>

   <button type="submit"
    ds-button
    class="w-100 mt-12"
    (click)="onCloseClick()"
    title="{{ 'drs.deny.close' | translate }}"><span>{{ 'drs.deny.close' | translate }}</span>
  </button>